var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fu"},[_c('h1',{staticClass:"title"},[_vm._v("如何查看电池BT码")]),_c('p',{staticClass:"test"},[_vm._v(" 小编在抓紧制作内容中，敬请期待哦 ")])])])
}]

export { render, staticRenderFns }